module.exports = {};



//////////////////
// WEBPACK FOOTER
// D:/Projects/GitHub/gvrogers/~/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = 0